<div id="top-container">
  <div class="app-title">{{ 'app_page_title' | l10n }}</div>
  <a href="{{ environment.societyUrl }}"><img class="logo" src="assets/images/{{ environment.societyLogoFile }}" alt="logo" /></a>
  <app-messages></app-messages>
  <router-outlet></router-outlet>
</div>
